import axios from "axios";
import AlertComponent from "../../components/AlertComponent";
import { Context } from "../../Reducers/Store";
import { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";


export default function Login() {
  let location = useLocation();

  const navigate = useNavigate();
  const [state, dispatch] = useContext(Context);

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");

  useEffect(() => {
    if (state.isLogged) {
      navigate("/", { state: { from: { pathname: location.state?.from?.pathname } } });
    }
  }, [])

  const handleLogin = (e) => {
    e.preventDefault();
    axios.post(process.env.REACT_APP_API + '/auth', { email, senha }).then(res => {
      dispatch({ type: "SET_LOGGED", payload: res.data });
      navigate("/dashboard", { state: { from: { pathname: location.state?.from?.pathname } } });
    }).catch(error => {
      const mensagem = error?.response?.data?.message || error?.message || "Erro desconhecido";
      AlertComponent("Erro", mensagem, { icon: "error" });
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
        <h1 className="text-2xl font-semibold text-center text-gray-800 mb-8">
          Login
        </h1>

        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              E-mail
            </label>
            <input
              type="email"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm
                         focus:outline-none focus:ring-2 focus:ring-slate-600"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Senha
            </label>
            <input
              type="password"
              placeholder="••••••••"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm
                         focus:outline-none focus:ring-2 focus:ring-slate-600"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-slate-900 hover:bg-slate-800 text-white py-2.5 rounded-md font-medium transition"
          >
            Entrar
          </button>

          <div className="flex justify-end">
            <Link
              to="/esqueci-senha"
              className="text-sm text-slate-600 hover:text-slate-900 hover:underline"
            >
              Esqueci minha senha
            </Link>
          </div>
        </form>

        <div className="mt-8 text-center text-xs text-gray-400">
          © {new Date().getFullYear()} Quality Digital
        </div>
      </div>
    </div>
  );
}
